<template>
    <component
        :is="component"
        v-bind="{ ...$attrs, ...variantProps }"
        @tab-click="(payload) => $emit('tab-click', payload)"
        @tab-change="(payload) => $emit('tab-change', payload)"
    >
        <slot />
    </component>
</template>

<script>
import ATabsV1 from './tabs-v1.vue';
import ATabsV2 from './tabs-v2.vue';

const VARIANTS = {
    1: ATabsV1,
    2: ATabsV2,
};

const VARIANT_ONLY_PROPS = {
    1: ['noTopSpacing', 'noBottomSpacing', 'useSmallTabs', 'withIcons', 'typeWidth'],
    2: ['theme', 'prevLabel', 'nextLabel', 'radius'],
};

export default {
    name: 'ATabs',
    components: {
        ATabsV1,
        ATabsV2,
    },
    inheritAttrs: false,
    props: {
        variant: {
            type: Number,
            validator: (prop) => [1, 2].includes(prop),
            default: 1,
        },
        radius: {
            type: Number,
            default: 32,
        },
        tabs: {
            type: Array,
            default: null,
        },
        activeTab: {
            type: Number,
            default: undefined,
        },
        controlled: {
            type: Boolean,
            default: false,
        },
        idPrefix: {
            type: String,
            default: undefined,
        },
        ariaLabel: {
            type: String,
            default: undefined,
        },
        storageKey: {
            type: String,
            default: undefined,
        },
        doNotSendGA: {
            type: Boolean,
            default: false,
        },
        noTopSpacing: {
            type: Boolean,
            default: false,
        },
        noBottomSpacing: {
            type: Boolean,
            default: false,
        },
        useSmallTabs: {
            type: Boolean,
            default: false,
        },
        withIcons: {
            type: Boolean,
            default: false,
        },
        typeWidth: {
            type: String,
            default: undefined,
        },
        theme: {
            type: String,
            validator: (prop) => !prop || ['light', 'dark'].includes(prop),
            default: 'light',
        },
        prevLabel: {
            type: String,
            default: undefined,
        },
        nextLabel: {
            type: String,
            default: undefined,
        },
    },
    emits: ['tab-click', 'tab-change'],
    computed: {
        resolvedVariant() {
            return VARIANTS[this.variant] ? this.variant : 1;
        },
        component() {
            return VARIANTS[this.resolvedVariant];
        },
        variantProps() {
            const shared = ['tabs', 'activeTab', 'controlled', 'idPrefix', 'ariaLabel', 'storageKey', 'doNotSendGA'];
            const forwarded = [...shared, ...VARIANT_ONLY_PROPS[this.resolvedVariant]];
            return Object.fromEntries(forwarded.map((prop) => [prop, this[prop]]));
        },
    },
};
</script>
